import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Het belang van eiwitten</title>
                <link rel="canonical" href={route("blogs.third")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Eiwitten, koolhydraten en vetten vormen samen de macronutriënten. Ieder hebben ze hun eigen belang en werking. Voor een gezond voedingspatroon is het ook van belang dat deze macronutriënten in balans zijn."
                />
                <meta
                    property="og:description"
                    content="Eiwitten, koolhydraten en vetten vormen samen de macronutriënten. Ieder hebben ze hun eigen belang en werking. Voor een gezond voedingspatroon is het ook van belang dat deze macronutriënten in balans zijn."
                />
                <meta property="og:url" content={route("blogs.third")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Het belang van eiwitten - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/eiwitten.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/eiwitten.webp"
                                    type="image/webp"
                                    alt="Eiwitten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/eiwitten.jpg"
                                    type="image/jpeg"
                                    alt="Eiwitten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/eiwitten.jpg"
                                    alt="Eiwitten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Het belang van eiwitten
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Eiwitten, koolhydraten en vetten vormen samen de
                        macronutriënten. Ieder hebben ze hun eigen belang en
                        werking. Voor een gezond voedingspatroon is het ook van
                        belang dat deze macronutriënten in balans zijn. In deze
                        blog gaan we eiwitten behandelen. Wat zijn eiwitten
                        precies, en waarom zijn ze zo belangrijk in ons
                        voedingspatroon.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat zijn eiwtten en waarvoor hebben we eiwitten nodig?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zoals gezegd is eiwit een voedingsstof. Eiwitten zijn
                        een belangrijk onderdeel van het menselijk lichaam. Je
                        kunt eiwitten beschouwen als de bouwstenen van je
                        lichaam. Ze zijn namelijk onder andere belangrijk voor
                        de opbouw en behoud van onze cellen. Dit meest bekende
                        zijn de spiercellen, maar ook voor de cellen in de
                        organen, zenuwstelsel, botten en zelfs in ons bloed zijn
                        eiwitten van belang. Hiermee hebben eiwitten ook een
                        functie bij het vervoer van stoffen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Niet alleen voor de opbouw van deze cellen zijn eiwitten
                        van belang. Ons lichaam breekt namelijk oude of
                        beschadigde eiwitten uit onze cellen af en vervangt deze
                        door nieuw eiwit. Daarom is het voor iedereen belangrijk
                        om voldoende eiwitten te eten, ongeacht of je veel of
                        weinig sport.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ook kunnen eiwitten als brandstof gebruikt worden. Ze
                        leveren namelijk ook energie. Voor eiwitten betref dit 4
                        kcal per gram eiwit. Als je lichaam te weinig
                        koolhydraten en/of vetten binnenkrijgt zullen eiwitten
                        aangesproken worden als energiebron. Ook als je teveel
                        eiwitten binnenkrijgt kunnen deze gebruikt worden als
                        energiebron.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast hebben eiwitten ook een functie bij
                        verschillende regelprocessen in het menselijk lichaam.
                        Dit komt doordat zowel enzymen als hormonen uit eiwitten
                        bestaan. Deze enzymen en hormonen sturen weer de
                        lichaamsprocessen aan.
                    </p>

                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe zijn eiwitten opgebouwd?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Eiwitten zijn een aaneenschakeling van aminozuren.
                        Aminozuren zijn weer opgebouwd uit verschillende
                        moleculen. Dit betreft koolstof (C), zuurstof (O),
                        stikstof (N) en zwavelmoleculen (S). Hiervan zijn
                        ontelbaar veel combinaties mogelijk, waardoor elk eiwit
                        weer uniek is.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Een deel van de eiwitten kan ons lichaam zelf aanmaken
                        maar sommige eiwitten moeten we uit onze voeding halen.
                        In totaal zijn er 22 verschillen soorten aminozuren.
                        Hiervan kan ons lichaam er zelf 14 aanmaken. Hiervan
                        zijn er 3 die het lichaam wel kan aanmaken, maar niet
                        altijd voldoende. Deze aminozuren worden benoemd als
                        semi-essentieel. Deze moet je net als de 8 overige
                        aminozuren uit je voeding halen. De 8 overige aminozuren
                        worden gezien als essentiële aminozuren en moeten
                        volledig uit voeding gehaald worden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Eiwitten in voeding
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        We maken onderscheid in 2 soorten eiwitten. Dit zijn
                        dierlijke eiwitten en plantaardige eiwitten. Dierlijke
                        eiwitten zitten in vlees, vis, eieren, kaas en
                        zuivelproducten. Deze dierlijke eiwitten bevatten alle
                        essentiële aminozuren. Daarom is het belangrijk om
                        voldoende van deze producten te eten in je
                        voedingspatroon. Daarnaast zitten in deze producten nog
                        meer belangrijke voedingsstoffen. Zo zitten er ook
                        vitamine B12, ijzer, calcium en magnesium in die
                        verschillende positieve effecten hebben op het lichaam.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zitten ook wel nadelen aan dierlijke eiwitten. Deze
                        producten kunnen ook veel verzadigd vet bevatten, wat
                        slecht is voor het hart en bloedvaten. Dit is
                        voornamelijk bij rood vlees het geval, dus daarom word
                        ook aangeraden niet te vaak rood vlees te eten.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Plantaardige eiwitten zitten in sojaproducten,
                        peulvruchten, granen, noten, zaden en paddenstoelen.
                        Plantaardige eiwitten bevatten in tegenstelling tot
                        dierlijke eiwitten niet alle essentiële eiwitten,
                        behalve sojaproducten. Deze bevatten ook alle essentiële
                        aminozuren.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoeveel eiwit moet je dan eten?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Afhankelijk van de hoeveelheid en intensiteit van
                        sporten moet je een bepaalde hoeveelheid eiwitten binnen
                        krijgen. Als je aan intensieve krachtsport doet is het
                        beste om 1,5 á 2 gram eiwit per kilo lichaamsgewicht
                        binnen te krijgen. Dit betekent dat een persoon van 80
                        kilogram dus 120 á 160 gram eiwitten per dag binnen moet
                        krijgen. Als je geen gebruik maakt van krachtsport zal 1
                        á 1,5 gram eiwit per lichaamsgewicht voldoende zijn.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Eiwitten in je voedingspatroon
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Een gevarieerd voedingspatroon is altijd belangrijk. Dit
                        geld ook voor de eiwitten die je binnenkrijgt. Een
                        gezond voedingspatroon bevat zowel dierlijke als
                        plantaardige eiwitten. Beide hebben hun voordelen en
                        door deze combinatie krijg je ten alle tijden de
                        essentiële aminozuren binnen voor je lichaam. Het is
                        veel vegetariërs of veganisten nog steeds mogelijk om
                        alle essentiële aminozuren binnen te krijgen met enkel
                        plantaardige eiwitten zoals bijvoorbeeld met tofu en
                        tempé.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Nu weet je wat eiwitten zijn, hoe deze zijn opgebouwd en
                        hoe je ervoor zorgt dat jij voldoende en gevarieerde
                        eiwitten binnenkrijgt. Hierbij zijn er genoeg opties om
                        te variëren, dus hoef je niet bang te zijn een eenzijdig
                        voedingspatroon te moeten volgen!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
